/**
 * User: herbert
 * Date: 10.03.16
 * Time: 12:59
 */

import React from 'react';
import Reflux from 'reflux';

import steleStore from '../stores/stele-store.js';
import storageStore from '../../userstorage/stores/storage-store.js';
import userStore from '../../userstorage/stores/user-store.js';

import storageActions from '../../userstorage/actions/storage-actions.js';


import T from '../../../nls/translate.js';

export default React.createClass({
	mixins: [
		Reflux.connect(storageStore, 'storage'),
		Reflux.connect(userStore, 'user')
	],
	getInitialState: function () {
		return {};
	},
	componentWillMount: function () {
		storageActions.send();
	},
	render: function () {
		const href = 'php/pdf.php?lang=' + T.current.key +
			(this.state.storage.token && this.state.storage.data && this.state.storage.data === steleStore.getKey() ?
				'&token=' + this.state.storage.token :
				'&data=' + steleStore.getKey()
			) +
			(this.state.user.pricesAllowed && this.state.user.pricesRequested ?
					'&needAuth=83612'
					: ''
			);
		return (
			<a target="_blank" href={href}>
				<div className="slx-stele-datasheet__link">
					<div className="slx-stele-datasheet__linktext">{T.current.DATASHEET.LINKTEXT}</div>
				</div>
			</a>
		);
	}
});
